<!-- <app-data-table [columns]="cols" [data]="systems" [title]="title"></app-data-table> -->


<ng-container>
  <app-data-table [columns]="cols" [data]="system" [isCardView]="false" (onPresentView)="getSystem()" [url]="'/access/user-roles/'"
    [isDeletable]="'/setup' | hasPermission: 'Delete'"  [showAddButton]="'/setup' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/setup' | hasPermission: 'Edit'"  [title]="title" (onAdd)="addSystem()" (editEventRow)="updateSystem($event)" [isView]="'/setup' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)" 
    (deleteEventRow)="showDeletePopup($event)" (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords">
  </app-data-table>
</ng-container>


<p-dialog header="Add Role" [(visible)]="showDialog" [modal]="true" [style]="{width: '500px' , height:'auto'}"
  [closable]="true" [dismissableMask]="true" [maximizable]="true">

 <form [formGroup]="systemForm" (ngSubmit)="onSubmitadd()" class="form-wrapper">
  <div>
    
    <!-- Name Field -->
    <div class="mt-4 mb-3">
      <label class="form-label"><b>Name *</b></label>
      <input type="text" class="form-control" formControlName="name" maxlength="100">
      <div class="text-danger mt-1" *ngIf="systemForm.get('name')?.touched && systemForm.get('name')?.hasError('required')">
        Name is required.
      </div>
      <div class="text-danger mt-1" *ngIf="systemForm.get('name')?.touched && systemForm.get('name')?.hasError('pattern')">
        Name can only contain alphanumeric characters and spaces.
      </div>
    </div>

    <!-- Code Field -->
    <div class="mt-4 mb-3">
      <label class="form-label"><b>Code *</b></label>
      <input type="text" class="form-control" formControlName="code" maxlength="100">
      <div class="text-danger mt-1" *ngIf="systemForm.get('code')?.touched && systemForm.get('code')?.hasError('required')">
        Code is required.
      </div>
      <div class="text-danger mt-1" *ngIf="systemForm.get('code')?.touched && systemForm.get('code')?.hasError('pattern')">
        Code can only contain alphanumeric characters and special symbols like - and _.
      </div>
    </div>

    <!-- Description Field -->
    <div class="mt-4 mt-3">
      <label for="section"><b>Description *</b></label>
      <textarea class="form-control" formControlName="description" rows="4" maxlength="500"></textarea>
      <div class="text-danger mt-1" *ngIf="systemForm.get('description')?.touched && systemForm.get('description')?.hasError('required')">
        Description is required.
      </div>
      <div class="text-danger mt-1" *ngIf="systemForm.get('description')?.touched && systemForm.get('description')?.hasError('pattern')">
        Description contains invalid characters. Only alphanumeric, commas, periods, parentheses, and hyphens are allowed.
      </div>
    </div>

  </div>

  <!-- Submit Button -->
  <div class="d-flex justify-content-end mt-3 btn-wrapper">
    <button type="submit" class="btn btn-primary" *ngIf="!viewMode" [disabled]="systemForm.invalid || systemForm.pristine">
      Submit
    </button>
  </div>
</form>

</p-dialog>


<p-dialog [header]="viewMode ? 'View Role' : 'Update Role'" [(visible)]="isUpdatedialog" [modal]="true" [style]="{width: '500px' , height:'auto'}"
  [closable]="true" [dismissableMask]="true" [maximizable]="true"
  [contentStyle]="{'display': 'flex', 'flexDirection': 'column', 'height': '100%' , 'justify-content' : 'space-between'}">

 <form [formGroup]="systemForm" (ngSubmit)="onSubmitEq()" class="form-wrapper">
  <div>
    
    <!-- Name Field -->
    <div class="mt-4 mb-3">
      <label class="form-label"><b>Name</b></label>
      <input type="text" class="form-control" formControlName="name" maxlength="100">
      <div class="text-danger mt-1" *ngIf="systemForm.get('name')?.touched && systemForm.get('name')?.hasError('required')">
        Name is required.
      </div>
      <div class="text-danger mt-1" *ngIf="systemForm.get('name')?.touched && systemForm.get('name')?.hasError('pattern')">
        Name can only contain alphanumeric characters and spaces.
      </div>
    </div>

    <!-- Code Field -->
    <div class="mt-4 mb-3">
      <label class="form-label"><b>Code</b></label>
      <input type="text" class="form-control" formControlName="code" maxlength="100">
      <div class="text-danger mt-1" *ngIf="systemForm.get('code')?.touched && systemForm.get('code')?.hasError('required')">
        Code is required.
      </div>
      <div class="text-danger mt-1" *ngIf="systemForm.get('code')?.touched && systemForm.get('code')?.hasError('pattern')">
        Code can only contain alphanumeric characters and special symbols like - and _.
      </div>
    </div>

    <!-- Description Field -->
    <div class="mt-4 mt-3">
      <label for="section"><b>Description</b></label>
      <textarea class="form-control" formControlName="description" rows="4" maxlength="500"></textarea>
      <div class="text-danger mt-1" *ngIf="systemForm.get('description')?.touched && systemForm.get('description')?.hasError('required')">
        Description is required.
      </div>
      <div class="text-danger mt-1" *ngIf="systemForm.get('description')?.touched && systemForm.get('description')?.hasError('pattern')">
        Description contains invalid characters. Only alphanumeric, commas, periods, parentheses, and hyphens are allowed.
      </div>
    </div>

  </div>

  <!-- Submit Button -->
  <div class="d-flex justify-content-end mt-3 btn-wrapper">
    <button type="submit" class="btn btn-primary" *ngIf="!viewMode" [disabled]="systemForm.invalid || systemForm.pristine">
      Submit
    </button>
  </div>
</form>

</p-dialog>

<p-dialog header="Delete Role" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete role ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()" class="mt-2">
    </p-button>
  </div>
</p-dialog>